import { useLocalObservable } from 'mobx-react-lite';
import React, { PropsWithChildren } from 'react';
import { createRootStores } from './root-store';
import { RootStoresContext } from './root-store';

export const RootStoresProvider: React.FC<PropsWithChildren> = (props) => {
  const {
    children,
  } = props;

  const stores = useLocalObservable(() => createRootStores());

  return (
    <RootStoresContext.Provider
      value={stores}
    >
      {children}
    </RootStoresContext.Provider>
  );
};
